import React from "react";
import { ProgressSpinner, ProgressSpinnerProps } from "@emisgroup/ui-progress-indicator";
import {
  Dialog,
  DialogContent
} from "../Index";
import "./Style.scss";

/**
 * Responsible for rendering the progress spinner component
 * @returns loader element
 */
export const UIProgressSpinner: React.FC<ProgressSpinnerProps> = (props: ProgressSpinnerProps) => {

  return (
    <Dialog
      onOpenChange={(): void => { return; }}
      open={true}
      className="qbl-progress__overlay"
      fullscreen={true}
    >
      <DialogContent>
        <ProgressSpinner
          {...props}
          delay={1}
          className="ui-progress-indicator"
        />
      </DialogContent>
    </Dialog>
  );
};
